import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [{
      path: '/Login',
      component: resolve => require(['@/page/Login.vue'], resolve),
    }, {
      path: '/',
      component: resolve => require(['@/page/index.vue'], resolve),
      redirect: '/shop_manage/store_information',
    },
    {
      path: '/index',
      component: resolve => require(['@/page/index.vue'], resolve),
      redirect: '/shop_manage/store_information',
      children: [
        // 设置
        {
          path: '/set_up/add_menu',
          component: resolve => require(['@/page/set_up/add_menu.vue'], resolve)
        },
        {
          path: '/set_up/menu_list',
          component: resolve => require(['@/page/set_up/menu_list.vue'], resolve)
        },
        {
          path: '/set_up/add_role',
          component: resolve => require(['@/page/set_up/add_role.vue'], resolve)
        },
        {
          path: '/set_up/role_list',
          component: resolve => require(['@/page/set_up/role_list.vue'], resolve)
        },
        {
          path: '/set_up/user_list',
          component: resolve => require(['@/page/set_up/user_list.vue'], resolve)
        },
        {
          path: '/set_up/addStaff',
          component: resolve => require(['@/page/set_up/addStaff.vue'], resolve)
        },

        // 首页
        {
          path: '/home/agreement',
          name: '协议',
          component: resolve => require(['@/page/home/agreement.vue'], resolve)
        },
        {
          path: '/home/app_update',
          name: 'App版本发布',
          component: resolve => require(['@/page/home/app_update.vue'], resolve)
        },
        {
          path: '/home/recording_collection',
          name: '录音采集',
          component: resolve => require(['@/page/home/recording_collection.vue'], resolve)
        },
        {
            path: '/home/app_index_modulr',
            name: 'App首页模块列表',
            component: resolve => require(['@/page/home/app_index_modulr.vue'], resolve)
        },
        {
            path: '/home/add_index_modulr',
            name: '添加App首页模块',
            component: resolve => require(['@/page/home/add_index_modulr.vue'], resolve)
        },
        {
            path: '/home/public_service_category',
            name: '便民服务分类',
            component: resolve => require(['@/page/home/public_service_category.vue'], resolve)
        },
        {
            path: '/home/add_public_service_category',
            name: '添加便民服务分类',
            component: resolve => require(['@/page/home/add_public_service_category.vue'], resolve)
        },
        {
            path: '/home/public_service_miniapp',
            name: '便民小程序入口',
            component: resolve => require(['@/page/home/public_service_miniapp.vue'], resolve)
        },
        {
            path: '/home/add_public_service_miniapp',
            name: '添加便民小程序入口',
            component: resolve => require(['@/page/home/add_public_service_miniapp.vue'], resolve)
        },
        {
            path: '/home/public_service_click_log',
            name: '便民服务跳转反馈',
            component: resolve => require(['@/page/home/public_service_click_log.vue'], resolve)
        },
        {
            path: '/home/public_service_search_log',
            name: '便民搜索统计',
            component: resolve => require(['@/page/home/public_service_search_log.vue'], resolve)
        },

        {
            path: '/home/article_list',
            name: '博客列表',
            component: resolve => require(['@/page/home/article_list.vue'], resolve)
        },
        {
            path: '/home/add_article',
            name: '添加博客',
            component: resolve => require(['@/page/home/add_article.vue'], resolve)
        },
        {
          path: '/home/course_manage',
          name: '课程管理',
          component: resolve => require(['@/page/home/course_manage.vue'], resolve)
        },
        {
            path: '/home/cooperation',
            name: '合作方式',
            component: resolve => require(['@/page/home/cooperation.vue'], resolve)
        },
        {
            path: '/home/cooperation_list',
            name: '商务合作',
            component: resolve => require(['@/page/home/cooperation_list.vue'], resolve)
        },

      {
        path: '/home/add_course',
        name: '添加课程',
        component: resolve => require(['@/page/home/add_course.vue'], resolve)
      },
      {
        path: '/home/chapter',
        name: '章节内容',
        component: resolve => require(['@/page/home/chapter.vue'], resolve)
      },
      {
        path: '/home/add_chapter',
        name: '添加章节',
        component: resolve => require(['@/page/home/add_chapter.vue'], resolve)
      },
      {
        path: '/home/movement',
        name: '推送记录列表',
        component: resolve => require(['@/page/home/movement.vue'], resolve)
      },
      {
        path: '/home/add_movement',
        name: '添加推送记录',
        component: resolve => require(['@/page/home/add_movement.vue'], resolve)
      },
      {
        path: '/home/look_news_detail',
        name: '查看推送详情',
        component: resolve => require(['@/page/home/look_news_detail.vue'], resolve)
      },
      {
        path: '/home/withdraw',
        name: '提现管理',
        component: resolve => require(['@/page/home/withdraw.vue'], resolve)
      },
        // 应用
        {
          path: '/software/index',
          name: '应用管理',
          component: resolve => require(['@/page/software/index.vue'], resolve)
        },
        {
          path: '/software/add_software',
          name: '添加应用',
          component: resolve => require(['@/page/software/add_software.vue'], resolve)
        },
        {
          path: '/shop_manage/application_detail',
          component: resolve => require(['@/page/shop_manage/application_detail.vue'], resolve)
        }, // 应用详情

        // 项目
        {
          path: '/project/index',
          component: resolve => require(['@/page/project/index.vue'], resolve)
        }, // 项目管理
        {
          path: '/project/add_project',
          component: resolve => require(['@/page/project/add_project.vue'], resolve)
        }, // 项目管理 - 添加项目 
        {
          path: '/project/project_list',
          component: resolve => require(['@/page/project/project_list.vue'], resolve)
        }, // 项目管理 - 阶段列表
        {
          path: '/project/add_stage',
          component: resolve => require(['@/page/project/add_stage.vue'], resolve)
        }, // 项目管理 - 阶段列表 - 添加阶段
        {
          path: '/project/service_content',
          component: resolve => require(['@/page/project/service_content.vue'], resolve)
        }, // 服务内容
        {
          path: '/project/add_content',
          component: resolve => require(['@/page/project/add_content.vue'], resolve)
        }, // 服务内容 - 添加内容
        {
          path: '/project/service_edition',
          component: resolve => require(['@/page/project/service_edition.vue'], resolve)
        }, // 服务管理
        {
          path: '/project/add_edition',
          component: resolve => require(['@/page/project/add_edition.vue'], resolve)
        }, // 服务管理 - 添加服务
        {
          path: '/project/service_label',
          component: resolve => require(['@/page/project/service_label.vue'], resolve)
        }, // 服务标签
        {
          path: '/project/add_label',
          component: resolve => require(['@/page/project/add_label.vue'], resolve)
        }, // 服务标签 - 添加标签

        //店铺管理
        {
          path: '/shop_manage/industry_list',
          component: resolve => require(['@/page/shop_manage/industry_list.vue'], resolve)
        }, // 行业分类
        {
          path: '/shop_manage/industry_add',
          component: resolve => require(['@/page/shop_manage/industry_add.vue'], resolve)
        }, //添加行业分类
        {
          path: '/shop_manage/case_manage',
          component: resolve => require(['@/page/shop_manage/case_manage.vue'], resolve)
        }, // 模板列表
        {
          path: '/shop_manage/case_detail',
          component: resolve => require(['@/page/shop_manage/case_detail.vue'], resolve)
        }, // 模板详情
        {
          path: '/shop_manage/case_menu_list',
          component: resolve => require(['@/page/shop_manage/case_menu_list.vue'], resolve)
        }, // 添加模板


        {
          path: '/shop_manage/store_information',
          component: resolve => require(['@/page/shop_manage/store_information.vue'], resolve)
        }, // 店铺信息
        {
          path: '/shop_manage/store_detail',
          component: resolve => require(['@/page/shop_manage/store_detail.vue'], resolve)
        }, // 店铺信息 - 店铺详情
        {
          path: '/shop_manage/create_shop',
          component: resolve => require(['@/page/shop_manage/create_shop.vue'], resolve)
        }, // 店铺信息 - 添加店铺
        {
          path: '/shop_manage/setup_shop',
          component: resolve => require(['@/page/shop_manage/setup_shop.vue'], resolve)
        }, // 店铺信息 - 设置菜单

        {
          path: '/shop_manage/shop_menu',
          component: resolve => require(['@/page/shop_manage/shop_menu.vue'], resolve)
        }, // 店铺菜单
        {
          path: '/shop_manage/case_menu_add',
          component: resolve => require(['@/page/shop_manage/case_menu_add.vue'], resolve)
        }, // 添加店铺菜单


        // 用户管理
        {
          path: '/user_management/user_list',
          component: resolve => require(['@/page/user_management/user_list.vue'], resolve)
        }, //平台客户
        {
          path: '/user_management/platform_detail',
          component: resolve => require(['@/page/user_management/platform_detail.vue'], resolve)
        }, //平台客户 - 详情
        {
          path: '/user_management/add_customer',
          component: resolve => require(['@/page/user_management/add_customer.vue'], resolve)
        }, //平台客户 - 录入客户
        {
          path: '/user_management/user_detail',
          component: resolve => require(['@/page/user_management/user_detail.vue'], resolve)
        }, //用户详情
        {
          path: '/user_management/user_add',
          component: resolve => require(['@/page/user_management/user_add.vue'], resolve)
        }, //添加用户
        {
          path: '/user_management/custom_user',
          component: resolve => require(['@/page/user_management/custom_user.vue'], resolve)
        }, //定制客户
        {
          path: '/user_management/index',
          component: resolve => require(['@/page/user_management/index.vue'], resolve)
        }, //天眼查客户
        {
          path: '/customer/export_cont',
          component: resolve => require(['@/page/user_management/export_cont.vue'], resolve)
        }, //天眼查客户 - 导入
        {
          path: '/user_management/index_detail',
          component: resolve => require(['@/page/user_management/index_detail.vue'], resolve)
        }, //天眼查客户 - 查看详情
        {
          path: '/user_management/customer_list',
          component: resolve => require(['@/page/user_management/customer_list.vue'], resolve)
        }, //定制需求 - 客户列表
        {
          path: '/user_management/customer_detail',
          component: resolve => require(['@/page/user_management/customer_detail.vue'], resolve)
        }, //定制需求 - 客户详情
        {
          path: '/user_management/customer_add',
          component: resolve => require(['@/page/user_management/customer_add.vue'], resolve)
        }, //定制需求 - 添加客户
        {
          path: '/user_management/customer_modify',
          component: resolve => require(['@/page/user_management/customer_modify.vue'], resolve)
        }, //定制需求 - 修改客户


        //平台管理
        {
          path: '/platform_manage/behavior_log',
          component: resolve => require(['@/page/platform_manage/behavior_log.vue'], resolve)
        }, //行为日志
        {
          path: '/platform_manage/behavior_type',
          component: resolve => require(['@/page/platform_manage/behavior_type.vue'], resolve)
        }, //合同管理
        {
          path: '/platform_manage/behavior_add',
          component: resolve => require(['@/page/platform_manage/behavior_add.vue'], resolve)
        }, //添加合同
        {
          path: '/platform_manage/channel_management',
          component: resolve => require(['@/page/platform_manage/channel_management.vue'], resolve)
        }, //渠道管理
        {
          path: '/platform_manage/channel_add',
          component: resolve => require(['@/page/platform_manage/channel_add.vue'], resolve)
        }, //渠道管理添加/修改

        {
          path: '/template/index',
          component: resolve => require(['@/page/template/index.vue'], resolve)
        }, // 应用模版
        {
          path: '/template/add',
          component: resolve => require(['@/page/template/add.vue'], resolve)
        }, // 添加 - 应用模版

        {
          path: '/template/version_list',
          component: resolve => require(['@/page/template/version_list.vue'], resolve)
        }, // 版本价格
        {
          path: '/template/version_add',
          component: resolve => require(['@/page/template/version_add.vue'], resolve)
        }, // 添加 - 版本价格
      ]
    },
    {
      path: '/h5/fill_info',
      component: resolve => require(['@/page/h5/fill_info.vue'], resolve)
    }, // 填写信息
    {
      path: '/h5/bind',
      component: resolve => require(['@/page/h5/bind.vue'], resolve)
    }, // 绑定成功
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js